import React, {useState, useEffect} from 'react'

import { PieChart, Pie, Cell, Legend, Tooltip, ResponsiveContainer } from 'recharts';
import ContentLoader from 'react-content-loader';

export default function TotalFinishedTasksChart(props) {

    const [ chartData, setChartData ] = useState(null);
    const [ maxPossibleResolutions, setMaxPossibleResolutions ] = useState(0);

    useEffect(() => {
        if (props.data) {
            /* calculate count of tasks which parent topic is mandatory */

            var countMandatoryTasks = 0;
            const mandatoryTopics = props.data.topics.filter(x => x.mandatory === true);
            
            if (mandatoryTopics.length > 1) {
                countMandatoryTasks = mandatoryTopics.map((entry) => {
                    return entry.tasks.length;
                }).reduce((a, b) => a + b);
            } else {
                countMandatoryTasks = mandatoryTopics.length === 1 ? mandatoryTopics[0].tasks.length : 0;
            }

            const submittedTotalResolutionCount = props.data.user_states.map((entry) => {
                return entry.states.filter(x => x === true).length;
            }).reduce((a, b) => a + b);


            var submittedMandatoryResolutionCount = 0;

            props.data.topics.map((topic, topicIndex) => {
                if (topic.mandatory === false) {
                    return;
                }

                const beforeTaskArray = props.data.topics.filter((filterEntry, filterIndex) => filterIndex < topicIndex).map(mapEntry => {
                    return mapEntry.tasks.length;
                });

                const targetStateIndex = beforeTaskArray.length > 0 ? beforeTaskArray.reduce((a, b) => a + b) : 0;

                props.data.user_states.map((user, userIndex) => {
                    user.states.slice(targetStateIndex, targetStateIndex + topic.tasks.length).map((state, stateIndex) => {
                        if (state === true) {
                            submittedMandatoryResolutionCount++;
                        }
                    });
                });
            });

            const remainingPossibleMandatoryRessolutions = (props.data.user_states.length * countMandatoryTasks) - submittedMandatoryResolutionCount;

            /* calculate not mandatory tasks */
            const countTasks = props.data.topics
                .map(entry => entry.tasks.length)
                .reduce((a, b) => a + b, 0);

            const countPossibleResolutions = props.data.user_states.length * countTasks;
            const countPossibleNotMandatoryResolutions = countPossibleResolutions - remainingPossibleMandatoryRessolutions;

            
            setChartData([{
                name: 'Erledigt',
                value: submittedTotalResolutionCount,
                color: '#28a745'
            }, {
                name: 'Ausstehend',
                value: countPossibleNotMandatoryResolutions - submittedTotalResolutionCount,
                color: '#ffc107'
            }, {
                name: 'Ausstehend (pflicht)',
                value: remainingPossibleMandatoryRessolutions,
                color: '#dc3545'
            }]);

            setMaxPossibleResolutions(countPossibleResolutions);
        }
    }, []);

    let renderLabel = function(entry) {
        return `${entry.name}: ${entry.value}`;
    }

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div className="rechart-custom-tooltip">
                    <b>{payload[0].name}</b>
                    <p className="m-0">{payload[0].value} von {maxPossibleResolutions} entspricht<br/>einem Anteil von {((payload[0].value / maxPossibleResolutions) * 100).toFixed(0)}%</p>
                </div>
            );
        }
      
        return null;
    };

    return (
        <>
            {
            chartData != null && chartData !== undefined ?
            <>
                <b className="d-block text-center">Anteile aller Aufgaben</b>
                
                <div style={{height: 400, overflowX: 'hidden'}}>
                    <ResponsiveContainer>
                        <PieChart minWidth={300} minHeight={300} className="d-block mx-auto">
                            <Pie data={chartData} dataKey="value" cx="50%" cy="50%" outerRadius={100} fill="#17a2b8" label={renderLabel} >
                                {
                                    chartData.map((entry, index) => {
                                        return <Cell 
                                            key={`cell-${index}`}
                                            fill={entry.color}
                                            strokeWidth={0} />
                                    })
                                }
                            </Pie>

                            <Legend />
                            <Tooltip content={<CustomTooltip />} />
                        </PieChart>
                    </ResponsiveContainer>
                </div>
            </>
            :
            <DummyPieChart />
        }
        </>
    )
}

const DummyPieChart = (props) => {
	return (
		<ContentLoader
			viewBox="0 0 400 200"
			height={200}
			width={400}
			style={{maxWidth: "100%"}}
			{...props}>
			<rect x="100" y="5" rx="0" ry="0" width="200" height="15" />
			<circle cx="140" cy="110" r="70" />
			<rect x="230" y="50" rx="0" ry="0" width="7" height="7" />
			<rect x="250" y="50" rx="0" ry="0" width="30" height="7" />
			<rect x="230" y="64" rx="0" ry="0" width="7" height="7" />
			<rect x="250" y="64" rx="0" ry="0" width="30" height="7" />
			<rect x="230" y="78" rx="0" ry="0" width="7" height="7" />
			<rect x="250" y="78" rx="0" ry="0" width="30" height="7" />
			<rect x="230" y="92" rx="0" ry="0" width="7" height="7" />
			<rect x="250" y="92" rx="0" ry="0" width="30" height="7" />
		</ContentLoader>
	);
};